"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'tools.convoTags.name': 'Conversation Tags',
    'tools.convoTags.description': 'Add relevant tags to conversations based on context',
};
